import script from "./footer-contact-links.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-contact-links.vue?vue&type=script&setup=true&lang=ts"

import "./footer-contact-links.vue?vue&type=style&index=0&id=075300fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075300fb"]])

export default __exports__